export default __webpack_public_path__ + "static/teaserImageLogin-277cf84021f6f54966e202a0116f7a9b.jpg";